export enum NewsCategoryEnum {
  TIPS = 'Tips',
  WOUW_ACTUA = '@WouwActua',
  PROBLEEM_VAN_DE_WEEK = 'Probleem van de week',
  AANKONDIGING = 'Aankondiging',
  RELEASE_NOTE = 'Release note',
}

export const ANNOUNCEMENT_CATEGORIES: string[] = [NewsCategoryEnum.AANKONDIGING, NewsCategoryEnum.RELEASE_NOTE];

export interface NewsCategoryInterface {
  id?: number;
  label?: string;
  icon?: string;
  displayOrder?: number;
  isDefault?: boolean;
  showMethodIcon?: boolean;
}
